import React, { Component } from 'react'
import styled from 'styled-components'
import { MdCheck } from 'react-icons/lib/md'
import content from '../../../data/indexContent'
import FullWidthSection from '../UI/FullWidthSection'
import CtaButtonLg from '../UI/CtaButtonLg'

class ChecklistBlurb extends Component {
  buildFeaturesList() {}

  render() {
    return (
      <ChecklistBlurbContainer>
        <FullWidthSection mobileHide>
          <div className="checklistBlurb">
            <h2 className="section-title" style={{ maxWidth: '500px' }}>
              Here's a few things our customers are already using AppTree for...
            </h2>
            <FeaturesList>
              {content.checklistItems.map(item => (
                <li key={Math.random()}>
                  <MdCheck style={iconStyle} /> {item}
                </li>
              ))}
            </FeaturesList>
            <div className="button-container">
              <CtaButtonLg to={'/contact'}>
                What will you use AppTree for?
              </CtaButtonLg>
            </div>
          </div>
        </FullWidthSection>
      </ChecklistBlurbContainer>
    )
  }
}

export default ChecklistBlurb

const iconStyle = {
  width: '25px',
  height: '25px',
  color: '#253858'
}

const FeaturesList = styled.ul`
  display: grid;
  grid-template-columns: repeat(3, 300px);
  justify-content: space-around;
  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
  }

  li {
    font-size: 2rem;
    color: #253858;
    line-height: 1.5;
  }
`

const ChecklistBlurbContainer = styled.div`
  .checklistBlurb {
    max-width: 900px;
    margin: auto;
    & h2 {
      color: #253858;
    }

    @media screen and (max-width: 768px) {
      width: 80%;
    }
  }

  .button-container {
    margin-top: 50px;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
`



// WEBPACK FOOTER //
// ./src/components/IndexContent/checklist_section.jsx